module.exports = "<main-navbar\n  ng-if=\"$ctrl.manager\"\n  employee=\"$ctrl.employee\"></main-navbar>\n\n<div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/features/mainRouting/mainRouting.html
// module id = 1030
// module chunks = 0